import { routePaths } from "../../../../routes/navigation";

export type OnlineCockpitView =
    | "overview"
    | "turnover"
    | "last-sale"
    | "groups"
    | "clients"
    | "avg-ticket"
    | "avg-items"
    | "hourly-revenue"
    | "defects"
    | "pricing"
    | "promotions"
    | "payments";

export const onlineCockpitViewLabels: Record<OnlineCockpitView, string> = {
    overview: "Обобщение",
    turnover: "Продажби общо",
    "last-sale": "Последна продажба",
    groups: "Стокови групи",
    clients: "Клиенти",
    "avg-ticket": "Средна касова бележка",
    "avg-items": "Средно артикули в една касова бележка",
    "hourly-revenue": "Оборот по часове",
    defects: "Брак и отписи",
    pricing: "Редовна / преоценка",
    promotions: "Акции",
    payments: "Плащания",
};

export const onlineCockpitViewShortLabels: Record<OnlineCockpitView, string> = {
    overview: "Обобщение",
    turnover: "Продажби",
    "last-sale": "Последна",
    groups: "Групи",
    clients: "Клиенти",
    "avg-ticket": "Бележка",
    "avg-items": "Артикули",
    "hourly-revenue": "Часове",
    defects: "Брак",
    pricing: "Преоценка",
    promotions: "Акции",
    payments: "Плащания",
};

const COCKPIT_VIEWS = new Set<string>(Object.keys(onlineCockpitViewLabels));

/** Два реда — основни изгледи и детайлни анализи (като Магазини). */
export const onlineCockpitViewRowLabels = ["Основни", "Детайли"] as const;

export const onlineCockpitViewRows: OnlineCockpitView[][] = [
    [
        "overview",
        "turnover",
        "hourly-revenue",
        "last-sale",
        "groups",
        "payments",
    ],
    [
        "clients",
        "avg-ticket",
        "avg-items",
        // "defects", // временно скрит в Онлайн
        // "pricing", // временно скрит в Онлайн
        // "promotions", // временно скрит в Онлайн
    ],
];

export const onlineCockpitTabViews: OnlineCockpitView[] = onlineCockpitViewRows.flat();

export function parseOnlineCockpitView(value: string | null): OnlineCockpitView {
    if (
        value === "stores"
        || value === "flow"
        || value === "promotions"
        || value === "defects"
        || value === "pricing"
    ) {
        return "overview";
    }

    if (
        value
        && COCKPIT_VIEWS.has(value)
        && value !== "promotions"
        && value !== "defects"
        && value !== "pricing"
    ) {
        return value as OnlineCockpitView;
    }

    return "overview";
}

export function buildOnlineCockpitHref(view: OnlineCockpitView): string {
    if (view === "overview") {
        return routePaths.onlineCockpit;
    }

    const params = new URLSearchParams();
    params.set("view", view);

    return `${routePaths.onlineCockpit}?${params.toString()}`;
}
